import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TopicDetail from "../pages/topic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/topic/:id",
    element: <TopicDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;